package com.nonopn.skywatcher.common.app.pages.map.model

import androidx.compose.ui.graphics.vector.ImageVector
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.weather_ash
import com.nonopn.skywatcher.common.app.res.weather_cloud
import com.nonopn.skywatcher.common.app.res.weather_drizzle
import com.nonopn.skywatcher.common.app.res.weather_dust
import com.nonopn.skywatcher.common.app.res.weather_fog
import com.nonopn.skywatcher.common.app.res.weather_haze
import com.nonopn.skywatcher.common.app.res.weather_lightning
import com.nonopn.skywatcher.common.app.res.weather_mist
import com.nonopn.skywatcher.common.app.res.weather_rainy
import com.nonopn.skywatcher.common.app.res.weather_sandstorm
import com.nonopn.skywatcher.common.app.res.weather_smoke
import com.nonopn.skywatcher.common.app.res.weather_snowy
import com.nonopn.skywatcher.common.app.res.weather_squall
import com.nonopn.skywatcher.common.app.res.weather_sunny
import com.nonopn.skywatcher.common.app.res.weather_tornado
import compose.icons.WeatherIcons
import compose.icons.weathericons.Cloud
import compose.icons.weathericons.Cloudy
import compose.icons.weathericons.DaySunny
import compose.icons.weathericons.Fog
import compose.icons.weathericons.Rain
import compose.icons.weathericons.Sandstorm
import compose.icons.weathericons.Snow
import compose.icons.weathericons.Thunderstorm
import compose.icons.weathericons.Tornado
import compose.icons.weathericons.Volcano
import compose.icons.weathericons.Windy
import eu.codlab.weather.common.models.WeatherConditionMap
import org.jetbrains.compose.resources.DrawableResource

fun WeatherConditionMap.drawable(): DrawableResource = when (this) {
    WeatherConditionMap.ThunderstormWithHeavyRain -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormWithLightRain -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormWithRain -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormLight -> Res.drawable.weather_lightning
    WeatherConditionMap.Thunderstorm -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormHeavy -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormRagged -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormWithLightDrizzle -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormWithDrizzle -> Res.drawable.weather_lightning
    WeatherConditionMap.ThunderstormWithHeavyDrizzle -> Res.drawable.weather_lightning
    WeatherConditionMap.DrizzleHeavyIntensity -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleHeavyShowerRain -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleHeavyIntensityRain -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleLightIntensity -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleLightIntensityRain -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleShowerRain -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleRain -> Res.drawable.weather_drizzle
    WeatherConditionMap.DrizzleShower -> Res.drawable.weather_drizzle
    WeatherConditionMap.Drizzle -> Res.drawable.weather_drizzle
    WeatherConditionMap.RainFreezing -> Res.drawable.weather_rainy
    WeatherConditionMap.RainExtreme -> Res.drawable.weather_rainy
    WeatherConditionMap.RainHeavyIntensity -> Res.drawable.weather_rainy
    WeatherConditionMap.RainVeryHeavy -> Res.drawable.weather_rainy
    WeatherConditionMap.RainModerate -> Res.drawable.weather_rainy
    WeatherConditionMap.RainShower -> Res.drawable.weather_rainy
    WeatherConditionMap.RainLightIntensityShower -> Res.drawable.weather_rainy
    WeatherConditionMap.RainLight -> Res.drawable.weather_rainy
    WeatherConditionMap.RainHeavyIntensityShower -> Res.drawable.weather_rainy
    WeatherConditionMap.RainRaggedShower -> Res.drawable.weather_rainy
    WeatherConditionMap.SnowHeavyShower -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowShower -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowHeavy -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowLight -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowSleet -> Res.drawable.weather_snowy
    WeatherConditionMap.Snow -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowSleetLightShower -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowShowerSleet -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowAndLightRain -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowAndRain -> Res.drawable.weather_snowy
    WeatherConditionMap.SnowLightShower -> Res.drawable.weather_snowy
    WeatherConditionMap.Mist -> Res.drawable.weather_mist
    WeatherConditionMap.Smoke -> Res.drawable.weather_smoke
    WeatherConditionMap.Haze -> Res.drawable.weather_haze
    WeatherConditionMap.DustSandWhirls -> Res.drawable.weather_sandstorm
    WeatherConditionMap.Fog -> Res.drawable.weather_fog
    WeatherConditionMap.Sand -> Res.drawable.weather_sandstorm
    WeatherConditionMap.Dust -> Res.drawable.weather_dust
    WeatherConditionMap.Ash -> Res.drawable.weather_ash
    WeatherConditionMap.Squall -> Res.drawable.weather_squall
    WeatherConditionMap.Tornado -> Res.drawable.weather_tornado
    WeatherConditionMap.Clear -> Res.drawable.weather_sunny
    WeatherConditionMap.CloudsFew -> Res.drawable.weather_cloud
    WeatherConditionMap.CloudsScattered -> Res.drawable.weather_cloud
    WeatherConditionMap.CloudsBroken -> Res.drawable.weather_cloud
    WeatherConditionMap.CloudsOvercast -> Res.drawable.weather_cloud
}

val WeatherConditionMap.icon: ImageVector
    get() = when (this) {
        WeatherConditionMap.ThunderstormWithHeavyRain -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormWithLightRain -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormWithRain -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormLight -> WeatherIcons.Thunderstorm
        WeatherConditionMap.Thunderstorm -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormHeavy -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormRagged -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormWithLightDrizzle -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormWithDrizzle -> WeatherIcons.Thunderstorm
        WeatherConditionMap.ThunderstormWithHeavyDrizzle -> WeatherIcons.Thunderstorm
        WeatherConditionMap.DrizzleLightIntensity -> WeatherIcons.Rain
        WeatherConditionMap.Drizzle -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleHeavyIntensity -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleLightIntensityRain -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleRain -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleHeavyIntensityRain -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleShowerRain -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleHeavyShowerRain -> WeatherIcons.Rain
        WeatherConditionMap.DrizzleShower -> WeatherIcons.Rain
        WeatherConditionMap.RainLight -> WeatherIcons.Rain
        WeatherConditionMap.RainModerate -> WeatherIcons.Rain
        WeatherConditionMap.RainHeavyIntensity -> WeatherIcons.Rain
        WeatherConditionMap.RainVeryHeavy -> WeatherIcons.Rain
        WeatherConditionMap.RainExtreme -> WeatherIcons.Rain
        WeatherConditionMap.RainFreezing -> WeatherIcons.Rain
        WeatherConditionMap.RainLightIntensityShower -> WeatherIcons.Rain
        WeatherConditionMap.RainShower -> WeatherIcons.Rain
        WeatherConditionMap.RainHeavyIntensityShower -> WeatherIcons.Rain
        WeatherConditionMap.RainRaggedShower -> WeatherIcons.Rain
        WeatherConditionMap.SnowLight -> WeatherIcons.Snow
        WeatherConditionMap.Snow -> WeatherIcons.Snow
        WeatherConditionMap.SnowHeavy -> WeatherIcons.Snow
        WeatherConditionMap.SnowSleet -> WeatherIcons.Snow
        WeatherConditionMap.SnowSleetLightShower -> WeatherIcons.Snow
        WeatherConditionMap.SnowShowerSleet -> WeatherIcons.Snow
        WeatherConditionMap.SnowAndLightRain -> WeatherIcons.Snow
        WeatherConditionMap.SnowAndRain -> WeatherIcons.Snow
        WeatherConditionMap.SnowLightShower -> WeatherIcons.Snow
        WeatherConditionMap.SnowShower -> WeatherIcons.Snow
        WeatherConditionMap.SnowHeavyShower -> WeatherIcons.Snow
        WeatherConditionMap.Mist -> WeatherIcons.Fog
        WeatherConditionMap.Smoke -> WeatherIcons.Fog
        WeatherConditionMap.Haze -> WeatherIcons.Fog
        WeatherConditionMap.DustSandWhirls -> WeatherIcons.Sandstorm
        WeatherConditionMap.Fog -> WeatherIcons.Fog
        WeatherConditionMap.Sand -> WeatherIcons.Sandstorm
        WeatherConditionMap.Dust -> WeatherIcons.Sandstorm
        WeatherConditionMap.Ash -> WeatherIcons.Volcano
        WeatherConditionMap.Squall -> WeatherIcons.Windy
        WeatherConditionMap.Tornado -> WeatherIcons.Tornado
        WeatherConditionMap.Clear -> WeatherIcons.DaySunny
        WeatherConditionMap.CloudsFew -> WeatherIcons.Cloudy
        WeatherConditionMap.CloudsScattered -> WeatherIcons.Cloudy
        WeatherConditionMap.CloudsBroken -> WeatherIcons.Cloudy
        WeatherConditionMap.CloudsOvercast -> WeatherIcons.Cloud
    }